<template>
  <div class="login" v-if="showLogin">
    <div class="login-box" :style="{ 'backgroundImage': 'url(' + require('@/assets/image/background2.svg') + ')' }">
      <div class="title flex justify-center align-center">
        <img src="@/assets/image/logo.png" alt="" />
        <p class="font-24">您未登录，请先登录后查看</p>
      </div>
      <div class="code-login">
        <p> <img src="@/assets/image/wx.png" alt="" />  请使用微信扫码登录</p>
        <div class="qr-code">
          <!-- <qrcode v-if="qrCode" :value="qrCode" size="160"></qrcode> -->
          <vue-qr ref="Qrcode" :text="qrCode" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
            :logoScale="0.2" :size="160"></vue-qr>
          <!-- <vue-qr text="Hello world!" :callback="test" qid="testid"></vue-qr> -->
          <div class="expire flex justify-center align-center" v-if="isExpire || isScan">
            <p v-if="isScan">扫码成功，等待确认</p>
            <div v-if="isExpire">
              <refresh-left class="icon" />
              <p class="font-14">二维码已过期，点击刷新</p>
            </div>
          </div>
        </div>
      </div>
	
	 <!-- <div class="loginBtn">
	    <a
	      href="https://work.goubudian.com/">
	      <img src="@/assets/image/qy_app.png"  alt="企业微信">
	    </a>
	  </div>
	    <div class="login_tips">Tips:现已支持安装企业微信小程序并通过企业微信发起活动！</div> -->
    </div>
  </div>
</template>
<script>
import { getH5Key, postCheckH5Key, loginUrl } from '../api/api'
import VueQr from 'vue-qr'
export default {
  name: 'loginbox',
  data() {
    return {
      qrCode: '',
      isScan: '',
      isExpire: '',
      showLogin: false,
      icon: require('@/assets/image/logo.png')
    }
  },
  components: {
    VueQr
  },
  methods: {
    fetchQrcode() {
      getH5Key().then(
        response => {
          if (response.data.code === 200) {
            this.qrCode = loginUrl + `?dzp_gzh_key=${response.data.data.dzp_gzh_key}`
            this.verifyQrcode(response.data.data.dzp_gzh_key)
          }
        },
        reject => {
          this.showLogin = false
          this.noQrcode = true
        }
      )
    },
    verifyQrcode(Qrcodekey) {
      clearInterval(this.checkTime)
      this.checkTime = setInterval(() => {
        postCheckH5Key({ dzp_gzh_key: Qrcodekey }).then(
          response => {
            // console.log(response.code)
            if (response.code === 200) {
              clearInterval(this.checkTime)
              this.$cookie.setCookie('token', response.data.token)
              this.$cookie.setCookie('userinfo', response.data)
              setTimeout(() => {
                this.$parent.fetchData()
                this.showLogin = false
              }, 500)
            } else if (response.code === 252) {
              // 用户已扫码
              this.isScan = true
            } else if (response.code === 251) {
              // console.log(response)
            } else if (response.code === 255) {
              clearInterval(this.checkTime)
              // console.log(response)
              this.isExpire = true
            }
          },
          reject => {
            clearInterval(this.checkTime)
            console.log(reject)
            this.isDated = true
          }
        )
      }, 3000)
    },
    login_fn(type) {
      this.showLogin = true
      this.fullscreenLoading = true
      clearInterval(this.checkTime)
      this.fetchQrcode()
    },
    close_Login() {
      this.showLogin = false
      clearInterval(this.checkTime)
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.align-center {
  align-items: center;
}

.font-12 {
  font-size: 12px;
}

.font-14 {
  font-size: 14px;
}

.font-18 {
  font-size: 18px;
}

.font-20 {
  font-size: 20px;
}

.font-24 {
  font-size: 24px;
}

.font-30 {
  font-size: 30px;
}

.cell {
  padding: 0 20px !important;
}

.login {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-size: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2999;
  left: 0;
  top: 0;
  .login-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 480px;
    background-color: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    text-align: center;
    border-radius: 25px;

    .title {
      padding-top: 40px;

      img {
        width: 48px;
        height: 48px;
        margin-right: 15px;
      }
    }

    .sub-title {
      padding-top: 15px;
    }

    .code-login {
      padding-top: 20px;
		
      .qr-code {
        position: relative;
        width: 160px;
        margin: 30px auto 0;

        .expire {
          flex-direction: column;
          color: #fff;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);

          .icon {
            width: 28px;
            height: 28px;
          }

          p {
			img{
				margin-right: 10px;
			}  
            margin-top: 10px;
          }
        }
      }
    }
	.login_tips{
		font-size: 12px;
		margin-top: 10px;
		color:#ff0000;
	}
	.loginBtn{
		
		width: 200px;
		height: 41px;
		margin: 50px auto 10px;
		img{
			width: 200px;
			height: 41px;
		}
	}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginBox.vue